import './MenuButton.scss';

import React, { PureComponent } from 'react';
import * as AriaMenuButton from 'react-aria-menubutton';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Icon from 'components/Icon';

import cxHelpers from 'util/className';

export const PLACEMENT_OPTIONS = ['left', 'right', 'top'];

@cxHelpers('MenuButton')
class MenuButton extends PureComponent {
  static propTypes = {
    onSelection: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        href: PropTypes.string,
        image: PropTypes.string,
        icon: PropTypes.string,
      })
    ),
    placement: PropTypes.oneOf(PLACEMENT_OPTIONS),
    menuItemClassname: PropTypes.string,
    onMenuToggle: PropTypes.func,
  };

  static defaultProps = {
    placement: PLACEMENT_OPTIONS[0],
    onMenuToggle: null,
  };

  renderMenuItem = item => {
    if (item.href) {
      return (
        <a className={this.cxEl('link')} href={item.href}>
          {this.renderMenuItemContent(item)}
        </a>
      );
    }
    if (item.link) {
      return (
        <Link className={this.cxEl('link')} to={item.link}>
          {this.renderMenuItemContent(item)}
        </Link>
      );
    }
    return this.renderMenuItemContent(item);
  };

  renderMenuItemContent = item => (
    <Box ellipsis>
      {item.image ? (
        <img
          src={item.image}
          alt={item.value}
          className={this.cxEl('menu-item-image')}
        />
      ) : null}
      {item.icon ? (
        <Icon type={item.icon} className={this.cxEl('menu-item-icon')} />
      ) : null}
      {item.value}
    </Box>
  );

  render() {
    const {
      children,
      options,
      onSelection,
      placement,
      menuItemClassname,
      onMenuToggle,
    } = this.props;

    return (
      <AriaMenuButton.Wrapper
        className={this.cx()}
        onSelection={onSelection}
        onMenuToggle={onMenuToggle}
      >
        <AriaMenuButton.Button className={this.cxEl('button')}>
          {children}
        </AriaMenuButton.Button>
        <AriaMenuButton.Menu
          className={this.cxEl('menu', { [placement]: placement })}
        >
          <ul>
            {options.map(item => (
              <li key={item.value}>
                <AriaMenuButton.MenuItem
                  className={this.cxEl(
                    'menu-item',
                    { 'with-link': item.href || item.link },
                    menuItemClassname
                  )}
                  value={item.value}
                >
                  {this.renderMenuItem(item)}
                </AriaMenuButton.MenuItem>
              </li>
            ))}
          </ul>
        </AriaMenuButton.Menu>
      </AriaMenuButton.Wrapper>
    );
  }
}

export default MenuButton;
